<template>
  <div class="enterpriseDetailMainBox">
    <div class="enterpriseDetailTop">
      <div class="enterpriseNameBox">
        <div class="enterpriseName">{{format.registerName}}</div>
        <div class="enterprisePhoto">
          <img src="../../../../assets/image/ic_qytx.png" />
        </div>
      </div>
      <div class="enterpriseBagesBox">
        <div class="locationBage">{{format.regionName}}</div>
        <div class="industryBage">{{format.industryCategoryName}}</div>
      </div>
      <div class="businessHoursBox">营业时间：{{format.timestamp}}</div>
      <div class="adressBox">详细地址：{{format.address}}</div>
    </div>
    <div class="companyDetailBox">
      <h2 class="companyDetailTitle">公司信息</h2>
      <div class="companyDetailList">
        <div class="companyDetailListItem">
          <span class="listTitle">⻔店名称</span>
          <div class="listContent">
            <span>{{format.name}}</span>
          </div>
        </div>
        <div class="companyDetailListItem">
          <span class="listTitle">法定代表⼈</span>
          <div class="listContent" @click="goRepresentative">
            <div class="to_icon">
              <img src="../../../../assets/image/t-right.png" />
            </div>
            <span>{{format.lawName}}</span>
          </div>
        </div>
        <div class="companyDetailListItem">
          <span class="listTitle">统⼀社会信⽤代码</span>
          <div class="listContent">
            <span>{{format.creditCode}}</span>
          </div>
        </div>
        <div class="companyDetailListItem">
          <span class="listTitle">经营许可证编号</span>
          <div class="listContent">
            <span>{{format.businessLicense}}</span>
          </div>
        </div>
        <div class="companyDetailListItem">
          <span class="listTitle">注册信息</span>
          <div class="listContent" @click="goRegister">
            <div class="to_icon">
              <img src="../../../../assets/image/t-right.png" />
            </div>
            <span>{{format.registerName}}</span>
          </div>
        </div>
        <div class="companyDetailListItem">
          <span class="listTitle">主营业务</span>
          <div class="listContent">
            <span>{{format.businessScope}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="companyPicListBox">
      <div class="companyPicListTop">
        <div class="companyPicListTilte">企业图⽚</div>
        <div class="companyPicCounts">共 {{companyPicList.length || 0}} 张</div>
      </div>
      <div class="companyPicList">
        <div class="companyPicListItem" v-for="(item, index) in companyPicList" :key="index">
          <img :src="addPrefix(item)" @click="showViewer(index, $event, companyPicList)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import api from '../../../../service/modules/integrity';
    export default {
        data () {
            return {
                companyPicList: [],
                format: {}
            };
        },
        created () {
            this.getEnterpriseDetail();
        },
        methods: {
            // 图片预览
            showViewer (index, event, imgList) {
                let url = imgList.map(item => {
                    return this.addPrefix(item);
                })
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:url|| [],
                    index
                  },
                })

                // this.$ImagePreview({
                //     images: url,
                //     startPosition: index,
                //     closeOnPopstate: true
                // });
            },
            // 法定代表人跳转
            goRepresentative () {
                this.$router.push({
                    path: 'legalPerson',
                    query: {
                        lawName: this.format.lawName,
                        lawTel: this.format.lawTel,
                        lawCertificateCode: this.format.lawCertificateCode,
                        lawCertificateType: this.format.lawCertificateTypeName
                    }
                });
            },
            // 注册信息跳转
            goRegister () {
                console.log(this.format.enterpriseNature);
                this.$router.push({
                    path: 'registrationInfo',
                    query: {
                        enterpriseNature: this.format.enterpriseNatureName,
                        registerCapital: this.format.registerCapital
                    }
                });
            },
            // 企业详情
            getEnterpriseDetail () {
                api
                    .enterpriseDetail({ enterpriseId: this.$route.query.enterpriseId })
                    .then(res => {
                        if (res.ret === 0) {
                            this.format = res.data;
                            if (res.data.photoUrls) {
                                this.companyPicList = res.data.photoUrls;
                            } else {
                                this.companyPicList = []
                            }
                        }
                    });
            },
            // 添加域名
            addPrefix (url) {
                let str = RegExp('http') || RegExp('https');
                let newUrl;
                str.test(url) ? newUrl = url : newUrl = 'https://' + url;
                return newUrl
            }
        }
    };
</script>

<style lang="less" scoped>
.enterpriseDetailMainBox {
  padding: 24px 16px;
  background-color: #fbfbfb;

  .enterpriseDetailTop {
    margin-bottom: 20px;
    padding: 16px 16px 0;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);

    .enterpriseNameBox::after {
      content: "";
      display: block;
      clear: both;
    }

    .enterpriseNameBox {
      margin-bottom: 4px;

      .enterpriseName {
        width: 220px;
        font-size: 16px;
        font-weight: 600;
        line-height: 30px;
        float: left;
      }

      .enterprisePhoto {
        width: 60px;
        height: 60px;
        background-color: #eee;
        border-radius: 3px;
        float: right;

        > img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .enterpriseBagesBox::after {
      content: "";
      display: block;
      clear: both;
    }

    .enterpriseBagesBox {
      padding-bottom: 12px;
      //   border-bottom: 1px solid #eee;
      > div {
        padding: 0 4px;
        font-size: 12px;
        line-height: 18px;
        border: 1px solid #36b374;
        color: #36b374;
        float: left;
      }

      > div:not(:last-child) {
        margin-right: 8px;
      }
      .locationBage {
        background: #fff;
        color: #2283e6;
        border: 1px solid #2283e6;
      }
    }

    .businessHoursBox {
      //   border-bottom: 1px solid #eee;
      line-height: 16px;
      font-size: 14px;
      color: #666666;
      margin-bottom: 16px;
    }

    .adressBox {
      line-height: 16px;
      font-size: 14px;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-bottom: 16px;
    }
  }

  .companyDetailBox {
    margin-bottom: 20px;
    padding: 16px 0 16px 0;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;

    .companyDetailTitle {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      padding-left: 16px;
    }

    .companyDetailList {
      .companyDetailListItem::after {
        content: "";
        display: block;
        clear: both;
      }

      .companyDetailListItem:not(:last-child) {
        border-bottom: 1px solid #eee;
      }

      .companyDetailListItem {
        padding: 14px 0;
        font-size: 14px;
        line-height: 20px;

        .listTitle {
          padding-left: 16px;
          width: 135px;
          float: left;
          font-size: 14px;
          color: #999;
        }

        .listContent::after {
          content: "";
          display: block;
          clear: both;
        }

        .listContent {
          margin-left: 145px;
          font-size: 14px;
          color: #333;
          text-align: right;
          padding-right: 16px;

          > span {
            width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            float: right;
          }

          .to_icon {
            width: 14px;
            height: 14px;
            margin: 2px 0 0 4px;
            float: right;
          }
        }
      }
    }
  }

  .companyPicListBox {
    margin-bottom: 20px;
    padding: 16px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;

    .companyPicListTop::after {
      content: "";
      display: block;
      clear: both;
    }

    .companyPicListTop {
      margin-bottom: 20px;
      line-height: 36px;

      .companyPicListTilte {
        font-size: 16px;
        font-weight: bold;
        float: left;
      }

      .companyPicCounts {
        font-size: 12px;
        float: right;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }
    }

    .companyPicList::after {
      content: "";
      display: block;
      clear: both;
    }

    .companyPicList {
      .companyPicListItem {
        width: 100px;
        height: 100px;
        margin: 0 6px 8px 0;
        background-color: #eee;
        border-radius: 3px;
        float: left;

        > img {
          width: 100%;
          height: 100%;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>
